(function () {
  "use strict";

  const modalParents = new Map();
  function moveModalToBody(modal) {
    if (!modal || modal.parentElement === document.body) {
      return;
    }
    if (!modalParents.has(modal.id)) {
      modalParents.set(modal.id, {
        parent: modal.parentElement,
        nextSibling: modal.nextSibling,
      });
    }
    document.body.appendChild(modal);
  }

  function restoreModalPosition(modal) {
    if (!modal) return;

    const originalPosition = modalParents.get(modal.id);
    if (originalPosition && originalPosition.parent) {
      if (originalPosition.nextSibling) {
        originalPosition.parent.insertBefore(
          modal,
          originalPosition.nextSibling
        );
      } else {
        originalPosition.parent.appendChild(modal);
      }
    }
  }

  document.addEventListener("modalOpen", function (evt) {
    if (
      evt.detail &&
      evt.detail.modalId &&
      evt.detail.modalId.includes("QuickShopModal")
    ) {
      const modal = document.getElementById(evt.detail.modalId);
      moveModalToBody(modal);
    }
  });

  document.addEventListener("modalClose", function (evt) {
    if (
      evt.detail &&
      evt.detail.modalId &&
      evt.detail.modalId.includes("QuickShopModal")
    ) {
      const modal = document.getElementById(evt.detail.modalId);
      setTimeout(function () {
        restoreModalPosition(modal);
      }, 500);
    }
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const target = mutation.target;

        if (target.classList.contains("modal--quick-shop")) {
          if (target.classList.contains("modal--is-active")) {
            moveModalToBody(target);
          } else if (
            !target.classList.contains("modal--is-active") &&
            !target.classList.contains("modal--is-closing")
          ) {
            setTimeout(function () {
              restoreModalPosition(target);
            }, 500);
          }
        }
      }
    });
  });

  function initObserver() {
    const modals = document.querySelectorAll(".modal--quick-shop");
    modals.forEach(function (modal) {
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObserver);
  } else {
    initObserver();
  }

  document.addEventListener("page:loaded", initObserver);
  document.addEventListener("shopify:section:load", initObserver);
})();
